const CHANNEL_NAME = "kubera:aiSync:reviewEvent";
const LOG_PREFIX = "[aiSync reviewEvent]";

export const aiSyncReviewEventType = {
  IMPORT_ABORTED: "import_aborted",
  IMPORT_COMPLETED: "import_completed"
};

let channel = null;
const getChannel = () => {
  if (channel) return channel;
  if (typeof BroadcastChannel === "undefined") return null;
  channel = new BroadcastChannel(CHANNEL_NAME);
  return channel;
};

export const broadcastAiSyncReviewEvent = (documentId, type) => {
  const ch = getChannel();
  if (!ch || !documentId || !type) return;
  ch.postMessage({ documentId, type });
};

export const subscribeAiSyncReviewEvents = callback => {
  const ch = getChannel();
  if (!ch) return () => {};
  const handler = event => {
    const { documentId, type } = event?.data || {};
    if (!documentId || !type) return;
    console.log(`${LOG_PREFIX} received type=${type} documentId=${documentId}`);
    callback({ documentId, type });
  };
  ch.addEventListener("message", handler);
  return () => ch.removeEventListener("message", handler);
};
